import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=947fdb44&scoped=true"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=947fdb44&prod&lang=scss&scoped=true"
import style1 from "./CreateCompany.vue?vue&type=style&index=1&id=947fdb44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947fdb44",
  null
  
)

export default component.exports